<template>
  <div>
    <v-row dense class="mb-2">
      <v-col class="text-right">
        <v-btn
          v-if="!showResults && !processing"
          @click="handleClickReview"
          outlined
          color="purple"
          small
          :loading="loading"
        >
          <v-icon class="mr-1" small>mdi-creation</v-icon>
          Rever texto
        </v-btn>
      </v-col>
    </v-row>

    <slot name="field"></slot>

    <v-expand-transition>
      <v-row v-if="processing">
        <v-col>
          <v-card outlined style="border-color: #9c27b2">
            <v-list-item class="purple--text">
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon color="purple" left size="20"> mdi-creation </v-icon>
                  A revisar com I.A. ...
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-progress-circular
                  size="25"
                  indeterminate
                  color="purple"
                ></v-progress-circular>
              </v-list-item-icon>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else-if="showResults">
        <v-col>
          <v-card outlined style="border-color: #9c27b2">
            <v-card-title class="purple--text subtitle-1">
              <v-icon color="purple" left size="20"> mdi-creation </v-icon>
              Revisão automática
            </v-card-title>
            <v-card-text
              class="purple--text"
              v-html="nlToBr(analysis.result?.established_facts)"
            >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-if="!reviewed">
                <v-btn @click="handleClickRefuse()" icon color="purple">
                  <v-icon>mdi-thumb-down-outline</v-icon>
                </v-btn>
                <v-btn @click="handleClickApprove()" icon color="purple">
                  <v-icon>mdi-thumb-up-outline</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <v-btn icon color="purple" :disabled="!refused">
                  <v-icon>mdi-thumb-down</v-icon>
                </v-btn>
                <v-btn icon color="purple" :disabled="!approved">
                  <v-icon>mdi-thumb-up</v-icon>
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-expand-transition>
  </div>
</template>

<script>
import {
  analyseEtablishedFacts,
  showEtablishedFacts,
  approveEtablishedFacts,
} from "@/services/products/products_llm";
import { nlToBr } from "@/tools/string";

export default {
  mixins: [],

  components: {},

  props: {
    reviewText: String,
    productId: [Number, String],
  },

  data() {
    return {
      loading: false,
      analysis: null,
      approved: false,
      refused: false,
      refreshPooling: null,
      nlToBr,
    };
  },

  methods: {
    startPooling() {
      this.refreshPooling = setInterval(() => this.refresh(), 1000);
    },

    async handleClickReview() {
      this.refused = false;
      this.approved = false;
      this.analysis = null;

      this.loading = true;
      try {
        const response = await analyseEtablishedFacts(this.productId, {
          established_facts: this.reviewText,
        });

        this.analysis = response.data.data;

        console.log(response.data.data);

        if (response.data.data.finished_at === null) {
          this.startPooling();
        }
      } finally {
        this.loading = false;
      }
    },
    async handleClickApprove() {
      this.approved = true;
      try {
        const response = await approveEtablishedFacts(this.productId, {
          approval: true,
        });

        this.$emit("approved", response.data.data.result.established_facts);

        setTimeout(() => {
          this.analysis = response.data.data;
        }, 2000);
      } catch (error) {
        this.approved = false;
      }
    },
    async handleClickRefuse() {
      this.refused = true;
      try {
        const response = await approveEtablishedFacts(this.productId, {
          approval: false,
        });

        setTimeout(() => {
          this.analysis = response.data.data;
        }, 2000);
      } catch (error) {
        this.refused = false;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        const response = await showEtablishedFacts(this.productId);
        if (response.status !== 200) {
          return;
        }

        this.analysis = response.data.data;

        if (response.data.data.finished_at !== null) {
          clearInterval(this.refreshPooling);
          this.refreshPooling = null;
        }
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    showResults() {
      return (
        this.analysis &&
        this.analysis.reviewed_at === null &&
        this.analysis.finished_at !== null
      );
    },
    processing() {
      if (!this.analysis) {
        return null;
      }

      return this.analysis.finished_at === null;
    },
    reviewed() {
      return this.approved || this.refused;
    },
  },

  async created() {
    await this.refresh();
    if (this.analysis.finished_at === null) {
      this.startPooling();
    }
  },

  destroyed() {
    if (this.refreshPooling) {
      clearInterval(this.refreshPooling);
      this.refreshPooling = null;
    }
  },
};
</script>
